export type IReplacements = Record<string, string | number>;

type IValidateKey<T, R> = (key: T, replacements?: IReplacements) => R;

export const validateKey =
    <T = string, R = string>(fn: IValidateKey<T, R>) =>
    (key: T, replacements?: IReplacements): R =>
        (key || Number(key) === 0 ? fn(key, replacements) : '') as R;
